import React from 'react';
import StaffDocumentsTab from '../StaffDocumentsTab';

export default function DocumentsTab({ username }) {
  if (!username) return null;
  return (
    <div className="pr-card" style={{ padding: 0, overflow: 'hidden' }}>
      <StaffDocumentsTab username={username} />
    </div>
  );
}
